export const getAvatarId = (jwt: string): number | undefined => {
    try {
        const jwtParts = jwt.split(".");

        if (jwtParts.length !== 3) {
            return undefined;
        }

        const payload = JSON.parse(atob(jwtParts[1] ?? ""));

        if (!("avatarId" in payload)) {
            return undefined;
        }

        return payload.avatarId;
    } catch {
        return undefined;
    }
};

export const getExpirationDate = (jwt: string): Date | undefined => {
    try {
        const jwtParts = jwt.split(".");

        if (jwtParts.length !== 3) {
            return undefined;
        }

        const payload = JSON.parse(atob(jwtParts[1] ?? ""));

        if (!("exp" in payload)) {
            return undefined;
        }

        return new Date(payload.exp * 1000);
    } catch {
        return undefined;
    }
};
